import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot} from "@angular/router";
import {EMPTY} from "rxjs";
import {catchError} from "rxjs/operators";
import { PropertyViewingUserContexts } from "../models/tenant-find/viewing-user-role-context";
import { ErrorService } from "../services/error.service";
import { TenantFindService } from "../services/tenant-find.service";

@Injectable()
export class ViewingConfirmResolver {

    constructor(
        private tenantFindService: TenantFindService,
        private errorService: ErrorService) {}

    resolve(route: ActivatedRouteSnapshot) {
        let guid = route.paramMap.get('guid')

        return this.tenantFindService.confirmAttendance(guid, PropertyViewingUserContexts.APPLICANT)
            .pipe(catchError(err => {
                this.errorService.logRoutingError(err);
                return EMPTY;
        }));
    }
}
